import { render, staticRenderFns } from "./AddLabOperatorModal.vue?vue&type=template&id=48aad65d&scoped=true&"
import script from "./AddLabOperatorModal.vue?vue&type=script&lang=js&"
export * from "./AddLabOperatorModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLabOperatorModal.vue?vue&type=style&index=0&id=48aad65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aad65d",
  null
  
)

export default component.exports